import { Box, Text, Flex, Icon } from '@chakra-ui/react'
import { formatAmount } from '@/helpers/formatAmount'
import CrownIcon from '@/public/assets/icons/crown-solid.svg'
import CashBagIcon from '@/public/assets/icons/cash-bag.svg'
import GameControllerIcon from '@/public/assets/icons/game-controller-solid.svg'
import ShoppingBagIcon from '@/public/assets/icons/shopping-bag.svg'
import TrophyIcon from '@/public/assets/icons/trophy-solid.svg'
import { USDC_DENOM_BASE } from '@/constants/constants'
import { UserStats } from '../templates/UserActivity/types'
import { useTranslation } from 'next-i18next/pages'
import { useFiatCurrencyStore } from '@/context/FiatCurrencyStore'

export const UserStatisticSummary = ({ data }: { data: UserStats }) => {
  const { t } = useTranslation()
  const isUsd = useFiatCurrencyStore((s) => s.isUsd())
  const formatBalance = useFiatCurrencyStore((s) => s.formatBalance)

  const formatUsdcAmount = (weiAmount: string) => {
    const human = parseFloat(formatAmount(weiAmount, { decimals: USDC_DENOM_BASE }))
    if (!isUsd) {
      return formatBalance(human)
    }
    return formatAmount(weiAmount, { decimals: USDC_DENOM_BASE }) + ' USDC'
  }

  return (
    <Box>
      <Text fontSize={'xl'} fontWeight={700} mb={5}>
        {t('stats.overall')}
      </Text>
      <Flex h={'calc(100% - 50px)'} flexDir={'column'} justifyContent={'space-between'}>
        <UserStatsRow icon={GameControllerIcon} title={t('stats.total-games')} value={data.totalGameCount} />
        <UserStatsRow icon={CrownIcon} title={t('stats.total-wins')} value={data.totalWinCount} />
        <UserStatsRow
          icon={CashBagIcon}
          title={t('stats.total-winnings')}
          value={formatUsdcAmount(data.totalWinAmount)}
        />
        <UserStatsRow icon={TrophyIcon} title={t('stats.top-win')} value={formatUsdcAmount(data.totalTopWinAmount)} />
        <UserStatsRow icon={ShoppingBagIcon} title={t('stats.referrals')} value={data.referralsCount} />
      </Flex>
    </Box>
  )
}

const UserStatsRow = ({ icon, title, value }: { icon: () => React.ReactElement; title: string; value: string }) => {
  return (
    <Box
      rounded={'2xl'}
      px={5}
      py={2.5}
      bg={'ninja.600'}
      mb={2}
      _last={{
        mb: 0,
      }}
    >
      <Flex alignItems={'center'} gap={4}>
        <Flex
          rounded={'xl'}
          p={4}
          w={14}
          h={14}
          bg={'ninja.500'}
          color={'ninja.100'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Icon width={'auto'} height={'auto'} as={icon} boxSize={6} color={'ninja.100'} />
        </Flex>
        <Box fontWeight={700}>
          <Text fontSize={'xl'}>{value}</Text>
          <Text fontSize={'sm'} color={'ninja.200'}>
            {title}
          </Text>
        </Box>
      </Flex>
    </Box>
  )
}
